import React from "react";
import withRoot from "../../withRoot";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Button } from "../../../node_modules/@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';
import green from '@material-ui/core/colors/green'

const styles = theme => ({
  stepsDone: {
    backgroundColor: '#F7F7F7',
    border: '1px #E6E6E6 solid',
    padding: '45px 15px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center'
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 60,
    color: green[300]
  },
});


class Step6 extends React.Component {

  render() {
    const { mainClasses, classes, handleGoToStart } = this.props;

    return (
      <React.Fragment>
        <div className={classes.stepsDone}>
          <Typography variant="subheading">Tallennus onnistui!</Typography>
          <DoneIcon className={classes.icon} />
        </div>
        <div className={mainClasses.buttonWrapper}>
          <Button className={mainClasses.stepButton} variant="outlined" onClick={handleGoToStart}>Palaa alkuun</Button>
        </div>
      </React.Fragment>
    );
  }
}


export default withRoot(withStyles(styles)(Step6));



// WEBPACK FOOTER //
// ./src/components/Steps/Step6.js